// extracted by mini-css-extract-plugin
export default {"qr":"HostCardQrCode_qr__6LTER"};